import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import "@/styles/components/slider.css";

document.querySelectorAll(".element-resources.as-slider").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Navigation],
    speed: 500,
    slidesPerView: 1,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    simulateTouch: false,
    watchSlidesProgress: true,
    centerInsufficientSlides: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 4,
      },
    },
  });
});
